module.exports = __webpack_public_path__ + "static/media/chevron-up-accent.d0546f73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-up-accent.svg
// module id = 63
// module chunks = 0